import type { PhysicalStoreRepository } from '../../domain/interfaces/PhysicalStoreRepository';
import type { StoreLocationWidgetData } from '../../domain/models/StoreLocationWidgetData';

export type PhysicalStoreService = ReturnType<typeof createPhysicalStoreService>;

export function createPhysicalStoreService(repo: PhysicalStoreRepository) {
  return {
    async getStoreLocationWidget(): Promise<StoreLocationWidgetData | null> {
      return repo.fetchStoreLocationWidget();
    },
    invalidateStoreLocationWidget(): void {
      repo.invalidateStoreLocationWidget();
    },
  };
}
